<template>
  <!-- 跳转到微信的中转页 -->
  <div class="main">
    <div class="home">
      <div class="downDiv">
        <!-- :icon="require('/src/assets/android.png')" -->
        <van-button class="download" @click="download">
          前往微信打开
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createLink } from "@/services/wxLink";
import { Notify } from "vant";
export default {
  components: {},

  data() {
    return {
      wxLink: "",
    };
  },
  async created() {
    //自动跳转
    let result = await createLink({
      platform: "plus",
      path: "/pages/pricePage/pricePage",
    });
    if (result.code === 200) {
      this.wxLink = result.data;
      window.location.href = this.wxLink;
    } else {
      Notify({
        type: "danger",
        message: result.message || "系统错误,请联系平台客服！",
      });
    }
  },
  methods: {
    download() {
      window.open(this.wxLink, "_blank", "");
    },
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
}
.home {
  position: relative;
  /* min-height: 90vh; */
  /* width: 100vw; */
  padding-top: 155%;
  background-color: #fff;
  background: url(../../image/wxLink/plus.png) no-repeat;
  /* background-size: cover; */
  background-position: center;
  background-size: 100%;
}

.downDiv {
  position: absolute;
  left: calc(100vw / 6);
  top: 80%;
}

.download {
  width: calc(100vw / 1.5);
  height: calc(100vh / 17);
  box-shadow: 1px 1px 5px #000;
  color: #fff !important;
  letter-spacing: 3px;
}
.van-button--default {
  color: #000;
  background-image: linear-gradient(to bottom right, #7ef74d, #26a02a);
  font-size: 18px;
  font-weight: 600;
}
</style>